import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { formatBytes } from 'helpers/storage';
import { CenterModal } from 'pages/album-view-mode/components/center-modal';
import styles from './out-of-storage-modal.module.scss';

interface OutOfStorageModalProps {
  vault: Pick<VaultType, 'storageLimit' | 'totalStorage'>;
  onClose: () => void;
}

// Shown when the user tries to add a file but the vault's storage plan is
// full (or the server rejects an upload with out_of_storage).
export const OutOfStorageModal = ({
  vault,
  onClose,
}: OutOfStorageModalProps) => (
  <CenterModal onClose={onClose}>
    <div className={styles.body}>
      <div className={styles.orb}>
        <svg className={styles.ring} viewBox="0 0 120 120" aria-hidden>
          <circle className={styles.ringTrack} cx="60" cy="60" r="52" />
          <circle className={styles.ringFill} cx="60" cy="60" r="52" />
        </svg>
        <span className={styles.orbCenter}>100%</span>
      </div>

      <span className={styles.title}>You&apos;re out of storage</span>
      <p className={styles.text}>
        {`This vault has used all ${formatBytes(vault.storageLimit)} of its plan, so new files can't be added right now.`}
      </p>
      <p className={styles.hint}>
        Free up space by deleting memories you no longer need — or move up to a
        bigger plan when creating your next vault.
      </p>

      <div className={styles.actions}>
        <Button
          buttonStyle={ButtonStyle.Primary}
          buttonSize={ButtonSize.Medium}
          onClick={onClose}
        >
          Got it
        </Button>
      </div>
    </div>
  </CenterModal>
);
